








import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'Banner',
  props: {
    src: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    }
  }
});
